// eslint-disable-next-line no-unused-vars
import qs from 'querystring';

const namespaced = true;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchListStudent({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/schedule/student`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListParent({ commit }, { studentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/schedule/student/${studentId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListTeacher({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/schedule/teacher`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListFilterTeacher({ commit }, { classroomId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/schedule/teacher/filter?classroomId=${classroomId}&courseId=${courseId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListFilterStudent({ commit }, { classroomId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/schedule/student/filter?classroomId=${classroomId}&courseId=${courseId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListFilterParent({ commit }, { classroomId, courseId, studentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/schedule/student/${studentId}/filter?classroomId=${classroomId}&courseId=${courseId}`);
      return data;
    } catch (err) {
      throw err;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
